import { StepHandle } from "..";
import { questionStepService } from "../../services/steps/question";
import { QuestionStepData, Step } from "../../types";
import { WorkflowManager } from "../../WorkflowManager";
import { Variant } from "../resource/variant";

export class QuestionStepHandle extends StepHandle<QuestionStepData> {
    constructor(manager: WorkflowManager, step: Step<QuestionStepData>, tags: string[]) {
        super(manager, step, tags);
    }

    async selectVariant(variant: Variant) {
        if (!variant.getId()) {
            throw new Error("Unable to select variant with a null ID");
        }
        await questionStepService.selectVariant(this.step, variant.getId(), this.manager);
    }

    /**
     * The way that this step expects to be rendered.
     */
    getDisplayType() {
        return (this.step.data as any).displayType || this.step.option?.displayType;
    }
}
